import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';

const FileListItemComponent = ({ file, handleDownload, handleDelete }: any) => {
  return (
    <li
      key={file.document_id}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '8px',
        backgroundColor: '#f0f0f0',
        borderRadius: '6px',
        color: '#333',
        fontSize: '14px',
        fontWeight: '500',
        border: '1px solid #ddd',
        marginBottom: '6px',
      }}
    >
      <span>{file.name}</span>
      <div style={{ display: 'flex', gap: '8px' }}>
        <DownloadIcon
          onClick={() => handleDownload(file)}
          style={{
            cursor: 'pointer',
            color: '#1976d2',
            fontSize: '20px',
          }}
        />
        {handleDelete && (
          <DeleteIcon
            onClick={() => handleDelete(file.document_id)}
            style={{
              cursor: 'pointer',
              color: '#d32f2f',
              fontSize: '20px',
            }}
          />
        )}
      </div>
    </li>
  );
};

export { FileListItemComponent };
